import React from "react";
import { IStat } from "../../types";
import { convertToNominal } from "../../utils/point";
import Card from "../../layouts/Card";

const CardStats = ({
  title,
  point,
  total,
  percentage,
  period: duration,
  icon,
  iconColor,
  to,
}: IStat): JSX.Element => {
  const CHANGE_COLOR =
    percentage >= 0.2
      ? "text-great"
      : percentage >= 0.1
      ? "text-good"
      : percentage >= 0
      ? "text-normal"
      : percentage <= -0.2
      ? "text-danger"
      : "text-warning";

  return (
    <Card to={to} className="w-full hover:scale-105" padding="px-3 py-3">
      <div className="relative flex flex-col break-words bg-white rounded mb-6 xl:mb-0 ">
        <div className="flex-auto">
          <div className="flex flex-wrap">
            <div className="relative w-full pr-4 max-w-full flex-grow flex-1">
              <h5 className="text-blueGray-400 uppercase font-bold text-xs">
                {title}
              </h5>
              <span className="font-semibold text-xl text-blueGray-700">
                {convertToNominal(point)}
              </span>
            </div>
            <div className="relative w-auto pl-4 flex-initial">
              <div
                className={`text-white p-3 text-center inline-flex items-center justify-center w-14 h-14 shadow-lg rounded-full ${iconColor}`}
              >
                <i className={icon}></i>
              </div>
            </div>
          </div>
          <p
            className={`text-sm text-gray-400 my-2 ${
              total || "text-transparent"
            }`}
          >
            Total:{" "}
            <span className="font-bold">
              {total && convertToNominal(total)}
            </span>
          </p>

          <p className="text-sm text-blueGray-400">
            <span className={`${CHANGE_COLOR} mr-2`}>
              <i
                className={
                  percentage > 0.05
                    ? "fas fa-arrow-up"
                    : percentage < -0.05
                    ? "fas fa-arrow-down"
                    : "fas fa-minus"
                }
              ></i>{" "}
              {Math.round(percentage * 100)}%
            </span>
            <span className="whitespace-nowrap">{duration}</span>
          </p>
        </div>
      </div>
    </Card>
  );
};

export default CardStats;
